/**
 * Derives a friendly display identity for a club's "front desk" from the
 * website they gave us — so the preview can greet them as, say, "Northside
 * Club" instead of echoing a raw URL. Purely cosmetic: the team confirms the
 * real name when they hand-build the genie.
 */
export interface DeskIdentity {
  /** Prettified name derived from the domain, e.g. "Northside Club". */
  name: string;
  /** Clean hostname, e.g. "northsideclub.org.nz". */
  domain: string;
}

export function deriveDeskIdentity(website: string | undefined | null): DeskIdentity | null {
  const trimmed = (website || "").trim();
  if (!trimmed) return null;

  const normalized = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  let host: string;
  try {
    host = new URL(normalized).hostname;
  } catch {
    return null;
  }

  const domain = host.replace(/^www\./i, "");
  if (!domain.includes(".")) return null;

  const firstLabel = domain.split(".")[0] || domain;
  const name = firstLabel
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return { name: name || domain, domain };
}
